import React from 'react'; // eslint-disable-line no-unused-vars
import styled from 'react-emotion';

const Youtube = styled('div')`
  margin: 0 auto;
  width: 100%;
  text-align: center;
`;

export default Youtube;
